import { FormattedMessage } from 'react-intl';

interface Props {
  isLoading: boolean;
  submitId: string;
  submittingId: string;
}

export default function SubmitButton({ isLoading, submitId, submittingId }: Props) {
  return (
    <button
      type="submit"
      disabled={isLoading}
      className="inline-flex w-full items-center justify-center rounded-lg bg-brand-700 px-4 py-3 text-sm font-semibold text-white transition hover:bg-brand-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-300 disabled:opacity-60"
    >
      <FormattedMessage id={isLoading ? submittingId : submitId} />
    </button>
  );
}
